import Vue from 'vue'
import Vuex from 'vuex'

import VuexPersistence from 'vuex-persist'
const vuexLocal = new VuexPersistence({
    storage: window.localStorage
})
Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        source: []
    },
    mutations: {

        source(state, payLoad) { state.source = payLoad },
        update_cihaz(state, payLoad) {
            console.log(payLoad)
            state.source[payLoad.index].cd = payLoad.payLoad.cdalias;
            state.source[payLoad.index].ktarih = payLoad.payLoad.chz_GrnBasTarihi;
            state.source[payLoad.index].lokasyon = payLoad.payLoad.chz_aciklama3;
        },
    },
    actions: {
        update_cihaz(context, payLoad) {

            return new Promise((resolve, reject) => {
                var index = context.getters.getsource.findIndex((word) => word.cihazid == payLoad.chz_Guid);
                if (index != -1) {
                    context.commit('update_cihaz', { index: index, payLoad })
                    resolve()

                }

            })
        },
        source(context, payLoad) {
            context.commit('source', payLoad)
        },
        view_servis(context, payLoad) {
            let info = []
            let cnt = 0
            return new Promise((resolve, reject) => {

                const start = async (payLoad, cihaz) => {
                    for (let index = 0; index < payLoad.data.length; index++) {
                        const e = payLoad.data[index];
                        var cihazindex = cihaz.findIndex((word) => word.cihazid == e.cid);
                        // var cari = await context.dispatch('carigetir', e.cid)
                        //console.log(cihaz[cihazindex])

                        if (cihazindex != -1) {

                            var unvan = cihaz[cihazindex].unvan || 0
                            var cari_kod = cihaz[cihazindex].carikod || 0
                            var adres = cihaz[cihazindex].adres || 0
                            var gsm = cihaz[cihazindex].gsm || 0
                            var mail = cihaz[cihazindex].mail || 0

                            if (cihaz[cihazindex].subeid == '') {
                                var cari = await context.dispatch('cari_getir', { data: e.carid, req: payLoad.req });
                                if (cari.status != 200) reject({ msg: 'Cari Hatası', "statuscode": "500" })
                                unvan = cari.data[0].unvan
                                cari_kod = cari.data[0].carikod
                                adres = cari.data[0].adres
                                gsm = cari.data[0].gsm
                                mail = cari.data[0].mail
                            }
                            let newobje = {
                                ...e,
                                cname: cihaz[cihazindex].cihazgrup,
                                model: cihaz[cihazindex].cihazaltgrup,
                                serino: cihaz[cihazindex].chz_serino,
                                lokasyon: cihaz[cihazindex].lokasyon,

                                cari_ad: unvan,
                                cari_kod: cari_kod,
                                adres: adres,
                                gsm: gsm,
                                mail: mail

                            }
                            info.push(newobje)
                            cnt++
                            if (payLoad.data.length == cnt) resolve(info)
                        }
                        else { reject({ msg: 'Cihaz Hatası', "statuscode": "500" }) }

                    }
                }
                start(payLoad, context.getters.getsource)
            })

        },
        cari_getir(context, payLoad) {
            //console.log(payLoad)
            return new Promise((resolve, reject) => {
                var data = "'" + payLoad.data + "'"
                payLoad.req.post("servis/api", { q: 'cari_adres',isim:'tesla', where: { alan: 'ca.adr_Guid =', value: data, status: true } })
                    .then(cari => {
                        //console.log(cari)
                        resolve(cari)
                    })
            })


        }
    },
    getters: {
        getsource(state) {
            return state.source
        },

    },
    plugins: [vuexLocal.plugin]

})


// WEBPACK FOOTER //
// ./src/store/index.js